/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Activity_Kind_ReminderInputs */



/**
* | output |
* | --- |
* | "Reminder" |
*
* @param {Chat_Activity_Kind_ReminderInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_activity_kind_reminder = /** @type {((inputs?: Chat_Activity_Kind_ReminderInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Activity_Kind_ReminderInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Geplande herinnering")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rappel")
	return /** @type {LocalizedString} */ ("Reminder")
});